import { __decorate, __metadata } from "tslib";
import { nameOf } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { AbstractPromotionCartActionDto, PromotionAddItemCartActionDto, PromotionAddPromotionCartActionDto, PromotionRemoveItemCartActionDto, PromotionRemovePromotionCartActionDto, PromotionUpdateItemCartActionDto, PromotionUpdatePromotionCartActionDto, } from '../../external';
import { PromotionExposeGroup, PromotionStoreUserResponseTypeEnum } from '../interface';
export class PromotionStoreUserErrorResponseDto {
}
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    ApiProperty({ type: () => String, example: PromotionStoreUserResponseTypeEnum.ERROR }),
    __metadata("design:type", String)
], PromotionStoreUserErrorResponseDto.prototype, "status", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], PromotionStoreUserErrorResponseDto.prototype, "errorMessage", void 0);
let PromotionStoreUserSuccessResponseDto = class PromotionStoreUserSuccessResponseDto {
};
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    ApiProperty({ type: () => String, example: PromotionStoreUserResponseTypeEnum.SUCCESS }),
    __metadata("design:type", String)
], PromotionStoreUserSuccessResponseDto.prototype, "status", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    Type(() => AbstractPromotionCartActionDto, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { value: PromotionAddPromotionCartActionDto, name: 'ADD_PROMOTION' },
                { value: PromotionRemovePromotionCartActionDto, name: 'REMOVE_PROMOTION' },
                { value: PromotionAddItemCartActionDto, name: 'ADD_ITEM' },
                { value: PromotionRemoveItemCartActionDto, name: 'REMOVE_ITEM' },
                { value: PromotionUpdateItemCartActionDto, name: 'UPDATE_ITEM' },
                { value: PromotionUpdatePromotionCartActionDto, name: 'UPDATE_PROMOTION' },
            ],
        },
    }),
    ApiProperty({
        oneOf: refs(PromotionAddPromotionCartActionDto, PromotionRemovePromotionCartActionDto, PromotionAddItemCartActionDto, PromotionRemoveItemCartActionDto, PromotionUpdateItemCartActionDto, PromotionUpdatePromotionCartActionDto),
    }),
    __metadata("design:type", Array)
], PromotionStoreUserSuccessResponseDto.prototype, "actions", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    ApiPropertyOptional({ type: () => String }),
    __metadata("design:type", String)
], PromotionStoreUserSuccessResponseDto.prototype, "description", void 0);
PromotionStoreUserSuccessResponseDto = __decorate([
    ApiExtraModels(PromotionAddPromotionCartActionDto, PromotionRemovePromotionCartActionDto, PromotionAddItemCartActionDto, PromotionRemoveItemCartActionDto, PromotionUpdateItemCartActionDto, PromotionUpdatePromotionCartActionDto)
], PromotionStoreUserSuccessResponseDto);
export { PromotionStoreUserSuccessResponseDto };
//# sourceMappingURL=PromotionStoreUserResponseDto.js.map